export const GET_DEVICE_GROUPS = "GET_DEVICE_GROUPS";